import * as Types from "../actions/types";
import {
	REPORT_AFFILIATE_INSERT,
	REPORT_AFFILIATE_LIST,
} from "../actions/types";

const init = {
	data: {},
	pagination: {},
	error: {},
	selected: {},
	success: "",
};

const reportReducer = (state = init, action) => {
	switch (action.type) {
		case Types.REPORT_AFFILIATE_LIST: {
			return {
				...state,
				data: action.payload.response.data,
				pagination: action.payload.response.pagination,
				selected: {},
				error: {},
			};
		}

		case Types.REPORT_AFFILIATE_INSERT: {
			if (Object.keys(state.data).length) {
				if (action.payload.data) {
					state.data.unshift(action.payload.data);
				}
			} else {
				state.data = action.payload.data;
			}

			return {
				...state,
			};
		}

		default:
			return state;
	}
};

export default reportReducer;
